import gsap from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

const line = document.querySelector("#steps .line svg.desktop path");
const lineMobile = document.querySelector("#steps .line svg.mobile path");
const lineLength = line?.getTotalLength();
const lineLengthMobile = lineMobile?.getTotalLength();

gsap.set(line, {
  strokeDasharray: lineLength,
  strokeDashoffset: lineLength,
});

gsap.set(lineMobile, {
  strokeDasharray: lineLengthMobile,
  strokeDashoffset: lineLengthMobile,
});

new SplitType("#steps .container > .title", {
  types: "chars, words",
});
gsap.from("#steps .container > .title .char", {
  opacity: 0.1,
  y: 10,
  stagger: 0.01,
  duration: 0.1,
  ease: "back.out(1.7)",
  scrollTrigger: {
    trigger: "#steps",
    start: "top center",
  },
});

gsap.to(line, {
  strokeDashoffset: 0,
  ease: "none",
  duration: 1.6,
  scrollTrigger: {
    trigger: "#steps",
    start: "top center",
    stagger: 1,
  },
});

gsap.to(lineMobile, {
  strokeDashoffset: 0,
  ease: "none",
  duration: 1.6,
  scrollTrigger: {
    trigger: "#steps",
    start: "top center",
    stagger: 1,
  },
});

gsap.fromTo(
  "#steps .line .point",
  {
    scale: 0,
    opacity: 0,
    "--_bottom": "0%",
    "--_scale": "0",
    "--_opacity": "0",
  },
  {
    scrollTrigger: {
      trigger: "#steps",
      start: "top center",
      stagger: 1,
    },
    duration: 1,
    scale: 1,
    opacity: 1,
    "--_bottom": "100%",
    "--_scale": "1",
    "--_opacity": ".4",
    ease: "back.out(1.7)",
  }
);